import React, { useState, useEffect } from "react";
import axios from "axios";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../../../Configuration/API_URL";
import FileIconGray from "./FileIconGray";
import KycSupport from "./KycSupport";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDocument,
  checkEmpty,
  checkString,
  checkStringNew,
  mobileNumber,
  noDataFound,
  noNomineeFound,
  splitDateSlash,
} from "../../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../../CommonMethhods/Constants";
import Loader from "../../../../Components/Common/Loader";
import { Form } from "react-bootstrap";

export default function DetailsKyc(props) {
  const [documentList, setDocumentList] = useState();
  const [viewDocList, setViewDocList] = useState([]);
  const [checkCode, setCheckCode] = useState("");
  const [loader, setLoader] = useState(true);
  const storeToken = localStorage.getItem("ssoToken");
  let kycBasicDetails = props.kycBasicDetails;
  const [selectedBank, setSelectedBank] = useState(null);
  const [bankList, setBankList] = useState([]);
console.log("kycBasicDetails",kycBasicDetails)
  const viewDocuments = async (definition_type) => {
    let clientCode = "";
    let payloadValue = {
      clientCode: checkCode,
      definition: definition_type,
      pan: "",
    };
    let encPayload = AESEncryption(payloadValue);

    try {
      const viewDocumentsList = await axios.post(
        DASHBOARD_CLIENT_OVERVIEW.DownloadAllDocuments_URL,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(viewDocumentsList?.data);

      const response = res.data.url;
      window.open(response, "_blank", "noopener,noreferrer");

      setViewDocList(response);
    } catch (error) {
      console.log(error);
    }
  };

  const kycUploadDocuments = async (clientCode) => {
    let payloadValue = { clientCode: clientCode, pan: "" };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDocumentsList = await axios.post(
        DASHBOARD_CLIENT_OVERVIEW.GetAllDocuments_URL,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const responseres = ApiResDecrypt(getDocumentsList?.data);
      if (typeof responseres?.data == "object") {
        setDocumentList(responseres?.data);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode")) {
      let clientCode = localStorage.getItem("clientCode");
      setCheckCode(clientCode);
      kycUploadDocuments(clientCode);
    }
  }, []);

  useEffect(() => {
    if (kycBasicDetails?.bankdtls?.length) {
      const primaryBank = kycBasicDetails?.bankdtls.find(
        (bank) => bank?.isPrimary === true
      );
      setSelectedBank(primaryBank);
      setBankList(kycBasicDetails?.bankdtls);
    }
  }, [kycBasicDetails]);

  const handleBankChange = (event) => {
    const selectedBankId = event.target.value;
    const bank = bankList.find(
      (bank) => bank?.bankId === parseInt(selectedBankId)
    );
    setSelectedBank(bank);
  };

  return (
    <>
      {/* <!-- KYC tabs --> 

      {/* <!-- Support/ Comments /Active/Inactive Session --> */}
      <div className="row gy-3  bottom-25">
        <KycSupport />
      </div>

      {/* <!-- basic Details --> */}
      <div className="card-box bottom-25">
        <div className="card-title">
          <h2>{Constants.Basic_Details}</h2>
        </div>
        <div className="table-wrapper">
          <div className="table-wrapper">
            <table className="table kyc-table">
              <tbody>
                <tr>
                  <td scope="col">{Constants.Full_Name}</td>
                  <td scope="col" className="color-green">
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails.name)}
                  </td>
                  <td>{Constants.Client_ID}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails.clientCode)}
                  </td>
                  <td>{Constants.PAN}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString && mobileNumber(kycBasicDetails.pan)}
                  </td>
                  {/* <td scope="col">{Constants.NAME_AS_IT_SITE}</td>
                  <td className="color-green text-uppercase">
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails.lName)}
                  </td> */}
                </tr>
                <tr>
                  <td>{Constants.FATHER_NAME}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails.mName)}
                  </td>
                  <td scope="col">{Constants.gender}</td>
                  <td scope="col">
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails.gender)}
                  </td>
                  {/* <td>{Constants.Mother_Name}</td>
                  <td>
                    {" "}
                    NA
                  </td> */}
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>{Constants.MARITAL_STATUS}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails.maritalStatus)}
                  </td>
                  <td>{Constants.DATE_OF_BIRTH}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString && splitDateSlash(kycBasicDetails.dob)}
                  </td>
                  <td></td>
                  <td></td>
                  {/* <td>{Constants.Client_ID}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails.clientCode)}
                  </td>
                  <td>{Constants.PAN}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString && mobileNumber(kycBasicDetails.pan)}
                  </td> */}
                </tr>
                {/* <tr>
                  <td>{Constants.NOMINEE}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails.isNominee)}
                  </td> */}
                {/* <td>AADHAR NUMBER</td>
                  <td>NA</td> */}

                {/* <td className="blank-column" colSpan="4"></td>
                </tr> */}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* <!-- Address Details --> */}
      <div className="card-box bottom-25 kyc-address">
        <div className="card-title">
          <h2>{Constants.Address_Details}</h2>
        </div>
        {/* {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : ( */}
        <div className="table-wrapper">
          <table className="table kyc-table">
            <tbody>
              <tr>
                <td>{Constants.ADDRESS_LINE_1}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.addressdtls.address1)}
                </td>
                <td>{Constants.CITY}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.addressdtls.city)}
                </td>
              </tr>
              <tr>
                <td>{Constants.ADDRESS_LINE_2}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.addressdtls.address2)}
                </td>
                <td>{Constants.STATE}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.addressdtls.state)}
                </td>
              </tr>
              <tr>
                <td>{Constants.ADDRESS_SAME}</td>
                <td>NA</td>
                <td>{Constants.ZIP_CODE}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.addressdtls.zip)}
                </td>
              </tr>
              <tr>
                <td>{Constants.CORRESPONDENCE_ADD_1}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.addressdtls.address1)}
                </td>
                <td>{Constants.CORRESPONDENCE_CITY}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.addressdtls.city)}
                </td>
              </tr>
              <tr>
                <td>{Constants.CORRESPONDENCE_ADDRESS_2}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.addressdtls.address2)}
                </td>
                <td>{Constants.CORRESPONDENCE_STATE}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.addressdtls.state)}
                </td>
              </tr>
              <tr>
                <td className="blank-column"></td>
                <td className="blank-column"></td>
                <td>{Constants.CORRESPONDENCE_ZIP}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.addressdtls.zip)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* )} */}
      </div>

      {/* <!-- Bank details and fatca --> */}
      <div className="row bottom-25">
        {/* <!-- Bank details --> */}
        <div className="col-md-6 bank-details">
          <div className="card-box">
            <div className="wrap-bank-header">
              <div className="card-title">
                <h2>{Constants.Bank_Details}</h2>
              </div>

              {kycBasicDetails?.bankdtls?.length ? (
                <div className="dropdown-filter bank-select">
                  <Form.Select
                    size="lg"
                    aria-label="Default select example"
                    value={selectedBank ? selectedBank?.bankId : ""}
                    onChange={handleBankChange}
                  >
                    {kycBasicDetails?.bankdtls.length ?
                      kycBasicDetails?.bankdtls.map((item) => {
                        const bankName = item?.bankName.split(" ")[0];
                        const accNumber = mobileNumber(item?.acNo);
                        let lastSix = accNumber.slice(-6);
                        let nameAccount =
                          bankName +
                          " - " +
                          lastSix +
                          (item?.isPrimary == true
                            ? " (Primary Account) "
                            : "");

                        return (
                          <option key={item?.bankId} value={item?.bankId}>
                            {nameAccount}
                          </option>
                        );
                      }): null}
                  </Form.Select>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.BANK_NAME}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(selectedBank?.bankName)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.BRANCH}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(selectedBank?.branch)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.ACCOUNT_NUMBER}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(mobileNumber(selectedBank?.acNo))}
                    </td>
                  </tr>

                  <tr>
                    <td>{Constants.IFSC_CODE}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(selectedBank?.ifsc)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.ACCOUNT_TYPE}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(selectedBank?.acType)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.PENNY_BENEFICIARY_NAME}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(selectedBank?.pennyBenName)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* <!-- paginantion --> */}
            {/* <nav aria-label="Page navigation " className="page-nav">
                <ul className="pagination">
                  <li className="page-item disabled">
                    <a
                      className="page-link"
                      href="javascript:void(0)"
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li className="page-item active">
                    <a className="page-link" href="javascript:void(0)">
                      1
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="javascript:void(0)">
                      2
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="javascript:void(0)">
                      3
                    </a>
                  </li>
                  <li className="page-item">
                    <a
                      className="page-link"
                      href="javascript:void(0)"
                      aria-label="Next"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav> */}
          </div>
        </div>

        {/* <!-- Fatca --> */}

        <div className="col-md-6 Fatca">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.Fatca}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.BIRTH_PLACE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.fatcadtls.NATIONALITY)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.POLITICAL_RELATION}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.fatcadtls.ISPOLITICAL)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.ITAX_COUNTRY}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.fatcadtls.TaxCountry)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.BIRTH_COUNTRY}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.fatcadtls.NATIONALITY)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.INCOME_SLAB}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.fatcadtls.INCOME_RANGE)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.OCCUPATION_CODE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.fatcadtls.OCCUPATION)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.TAX_ID_NUMBER}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.fatcadtls.TaxIdNumber)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- user upload documents --> */}

      <div className="card-box bottom-25">
        <div className="card-title">
          <h2>{Constants.User_Uploaded_Documents}</h2>
        </div>
        <div className="table-wrapper">
          <table className="table kyc-table">
            <tbody>
              <tr>
                <td>{Constants.ADDRESS_PROOF_FRONT}</td>
                <td>
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList.useruploadeddocuments.addressprooffront
                    )
                  )}
                </td>
                <td>{Constants.ADDRESS_PROOF_REAR}</td>
                <td>
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList.useruploadeddocuments.AddressProofrear
                    )
                  )}
                </td>
              </tr>
              <tr>
                {/* <td>{Constants.ADDRESS_PROOF_TYPE}</td>
                <td>
                  {checkEmpty(documentList)
                    ? "-"
                    : checkStringNew(
                        documentList.useruploadeddocuments.AddressProoftype
                      )}
                </td> */}
                <td>{Constants.PAN_CARD_FILE}</td>
                <td>
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList.useruploadeddocuments.pancardfile
                    )
                  )}
                </td>
                <td>{Constants.INV_PHOTO_FILE}</td>
                <td className="table-icon">
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList.useruploadeddocuments.invphotofile
                    )
                  )}
                </td>
              </tr>
              {/* <tr>
               
                <td>{Constants.GEO_LOCATION}</td>
                <td>
                  {checkEmpty(documentList)
                    ? "-"
                    : checkStringNew(
                        documentList.useruploadeddocuments.invphotogeolocation
                      )}
                </td>
              </tr> */}
              <tr>
                <td>{Constants.INV_SIGN_FILE}</td>
                <td className="table-icon">
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList.useruploadeddocuments.invsignfile
                    )
                  )}
                </td>
                <td>{Constants.INCOME_PROOF_FILE}</td>
                <td>
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList.useruploadeddocuments.incomeprooffile
                    )
                  )}
                </td>

                {/* <td>{Constants.INV_SIGN_FILE_FORMAT}</td>
                <td>
                  {checkEmpty(documentList)
                    ? "NA"
                    : checkString(
                        documentList.useruploadeddocuments.invphotofileformat
                      )}
                </td> */}
              </tr>
              {/* <tr>
                

                <td>{Constants.INCOME_PROOF_TYPE}</td>
                <td>
                  {checkEmpty(documentList)
                    ? "-"
                    : checkStringNew(
                        documentList.useruploadeddocuments.incomeprooftype
                      )}
                </td>
              </tr> */}
              <tr>
                {/* <td>{Constants.POA_FILE}</td>
                <td className="table-icon">
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList.useruploadeddocuments.poafile
                    )
                  )}
                </td> */}
                <td>{Constants.CHEQUE_FILE}</td>
                <td>
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList.useruploadeddocuments.chequefile
                    )
                  )}
                </td>
                <td></td>
                <td></td>
              </tr>
              
              {/* <tr>
                <td>{Constants.IDENTIFIER_NUMBER}</td>
                <td>
                  {checkEmpty(documentList)
                    ? "NA"
                    : checkString(
                        documentList.useruploadeddocuments.identifiernumber
                      )}
                </td>
                <td>{Constants.EXPIRY_DATE}</td>
                <td>
                  {checkEmpty(documentList)
                    ? "NA"
                    : checkString(
                        documentList.useruploadeddocuments.expirydate
                      )}
                </td>
              </tr> */}
              {/* <tr>
                <td scope="col">{Constants.IPV_FILE}</td>
                <td>
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList.useruploadeddocuments.ipvfile
                    )
                  )}
                </td>
                <td className="blank-column" colSpan="2"></td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>

      {/* <!-- income and ipv details --> */}
      <div className="row bottom-25">
        {/* <!-- income details --> */}
        <div className="col-md-6 income-details">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.Income_Details}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.INCOME_PROOF_TYPE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(
                            kycBasicDetails.incomeDetails.income_proof_type
                          )}
                    </td>
                  </tr>
                  {/* <tr>
                    <td>{Constants.TAX_COUNTRY}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(
                            kycBasicDetails.incomeDetails.tax_country
                          )}
                    </td>
                  </tr> */}
                  <tr>
                    <td>{Constants.EXPERIENCE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.incomeDetails.Experience)}
                    </td>
                  </tr>
                  {/* <tr>
                    <td>{Constants.INCOME_DATE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.incomeDetails.incomeDate)}
                    </td>
                  </tr> */}
                  <tr>
                    <td>{Constants.INCOME_SLAB}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.incomeDetails.slab)}
                    </td>
                  </tr>
                  {/* <tr>
                    <td>{Constants.INCOME_TYPE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.incomeDetails.incomeType)}
                    </td>
                  </tr> */}
                  <tr>
                    <td>{Constants.OCCUPATION}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.incomeDetails.occupation)}
                    </td>
                  </tr>
                  {/* <tr>
                    <td>{Constants.POLITICS}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(
                            kycBasicDetails.incomeDetails.isPolitical
                          )}
                    </td>
                  </tr> */}
                  <tr>
                    <td>{Constants.QUALIFICATION}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        // : checkString(
                        //     kycBasicDetails.incomeDetails.qualification
                        :
                        kycBasicDetails.incomeDetails.qualification?kycBasicDetails.incomeDetails.qualification:"-"
                          }

                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.INCOME_PROOF_FILE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.incomeDetails.document)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* <!-- <!IPV details --> */}
        {/* <div className="col-md-6 ipv-details">
        {/* <div className="col-md-6 ipv-details">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.IPV_Details}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.IPV_NAME}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails.ipvDetail.ipvName)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.IPV_EMPLOYEE_CODE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails.ipvDetail.ipvEmpCode)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.IPV_OTP}</td>
                    <td>NA</td>
                  </tr>
                  <tr>
                    <td>{Constants.IPV_FILE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails.ipvDetail.ipvFiles)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.IPV_FACEMATCH}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails.ipvDetail.ipvFaceMatch)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.IPV_LOCATION}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails.ipvDetail.ipvLocation)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.CREATED_DATE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails.ipvDetail.create_date)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.MODIFIED_DATE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails.ipvDetail.modifiedDate)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> */}

          {/* <!--Nominee details --> */}
          <div className="col-md-6 nominee-details">
          <div className="card-box">
            <div className="card-title mb-0">
              <h2>{Constants.Nominee_Details}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  {checkEmpty(kycBasicDetails) ? (
                    <tr className="nominee-noData">
                      <td className="border-bottom-none">{noNomineeFound()}</td>
                      {/* <td className="zeroBday">{Constants.No_Data}</td> */}
                    </tr>
                  ) : kycBasicDetails.nomineeDetailtls.length <= 0 ? (
                    <tr className="nominee-noData">
                      <td className="border-bottom-none">{noNomineeFound()}</td>
                      {/* <td className="zeroBday">{Constants.No_Data}</td> */}
                    </tr>
                  ) : (
                    kycBasicDetails.nomineeDetailtls.map((item, index) => {
                      return (
                        <>
                          <h4 className="pt-4">NOMINEE {index + 1}</h4>
                          <tr className="d-flex flex-column">
                            <div className="d-flex justify-content-between w-75">
                              <td className="p-3">NAME</td>
                              <td className="text-start p-3">{item.name}</td>
                            </div>
                            <div className="d-flex justify-content-between w-75">
                              <td className="p-3">RELATION</td>
                              <td className="text-start p-3">
                                {item.Relation}
                              </td>
                            </div>
                          </tr>
                        </>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- forms and backoffice uploads --> */}
      <div className="row bottom-25">
        {/* <!-- Forms details --> */}
        <div className="col-md-6 forms-details">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.Forms}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.AOF_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(viewDocuments, documentList.forms.aoffile)
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.CKYC} </td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(viewDocuments, documentList.forms.ckyc)
                      )}
                    </td>
                  </tr>
                  {/* <tr>
                    <td>{Constants.CLIENT_REGISTRATION_FILE}</td>
                    <td className="table-icon">
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList.forms.clientregistrationfile
                        )
                      )}
                    </td>
                  </tr> */}
                  {/* <tr>
                    <td>{Constants.COMMODITY_REGISTRATION_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList.forms.commodityregistrationfile
                        )
                      )}
                    </td>
                  </tr> */}
                  {/* <tr>
                    <td>{Constants.EQUITY_CODE}</td>
                    <td>
                      {checkEmpty(documentList)
                        ? "NA"
                        : checkString(documentList.forms.equitycode)}
                    </td>
                  </tr> */}
                  {/* <tr>
                    <td>{Constants.COMMODITY_CODE}</td>
                    <td>
                      {checkEmpty(documentList)
                        ? "NA"
                        : checkString(documentList.forms.commoditycode)}
                    </td>
                  </tr> */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* <!--Backoffice Uploads --> */}
        <div className="col-md-6 backoffice-uploads">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.Backoffice_Uploads}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.KRA_PAGE_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList.backofficeuploads.krapagefile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.KRA_ADDRESS_PROOF_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList.backofficeuploads.kraaddressprooffile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.KRA_PAN_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList.backofficeuploads.krapanfile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.BO_INCOME_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList.backofficeuploads.boincomefile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.PAN_IT_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList.backofficeuploads.panitfile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.POA_FILE}</td>
                    <td>
                      {" "}
                      NA
                      {/* {documentList == undefined || null || " " ? (
                        "NA"
                      ) : documentList.backofficeuploads.extradocumentfile ==
                          undefined || null ? (
                        "NA"
                      ) : (
                        <a
                          onClick={() =>
                            viewDocuments(
                              documentList.backofficeuploads.extradocumentfile
                            )
                          }
                        >
                          <span className="color-green site-icons icon-pdf"></span>
                        </a>
                      )} */}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.EXTRA_DOCUMENT_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList.backofficeuploads.extradocumentfile
                        )
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- aadhaar and nominee details section --> */}
      <div className="row bottom-25">
        {/* <!-- aadhaar details --> */}
        {/* <div className="col-md-6 aadhaar-details">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.Aadhaar_Documents}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.Aadhaar_Documents}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList.aadhardocuments.aadharfile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.AADHAAR_PHOTO}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList.aadhardocuments.aadharphoto
                        )
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> */}
      
      </div>

      {/* <!-- Others Details --> */}
      <div className="card-box bottom-25 other-details">
        <div className="card-title">
          <h2>{Constants.Others}</h2>
        </div>
        <div className="table-wrapper">
          <table className="table kyc-table">
            <tbody>
              <tr>
                <td>{Constants.ONBOARD_STATUS}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.onboardstatus)}
                </td>
                {/* <td>Created</td> */}
                <td>{Constants.AUTH_ONBOARD_STATUS}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.authonboardstatus)}
                </td>
              </tr>
              <tr>
                <td>{Constants.APPROVAL_STATUS}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.approvalstatus)}
                </td>
                {/* <td>Yes</td> */}
                <td>{Constants.ESIGN_STATUS}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.esignstatus)}
                </td>
                {/* <td>Yes</td> */}
              </tr>
              <tr>
                <td>{Constants.EKYC_SUBMITTED_STATUS}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.ekycsubmittedstatus)}
                </td>
                {/* <td>No</td> */}
                <td>{Constants.ESIGN_CONSENT}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.esignconsent)}
                </td>
                {/* <td>No</td> */}
              </tr>
              <tr>
                <td>{Constants.ESIGN_CONSENT_TS}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.esignconsentts)}
                </td>
                {/* <td>Nov 21, 2020, 7:06:39 PM</td> */}
                <td>{Constants.IP_ADDRESS}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.ipaddress)}
                </td>
              </tr>
              <tr>
                <td>{Constants.DEVICE_ID}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.deviceid)}
                </td>
                {/* <td>Android</td> */}
                <td>{Constants.KYC_VERIFIED}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.kycverified)}
                </td>
                {/* <td>No</td> */}
              </tr>
              <tr>
                <td>{Constants.AADHAAR_VERIFIED}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.aadharverified)}
                </td>
                {/* <td>No</td> */}
                <td>CREATED DATE</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.createdat)}
                </td>
                {/* <td>Onboarding</td> */}
              </tr>
              <tr>
                <td>ONBOARDED DATE</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.onboardedat)}
                </td>
                {/* <td>Nov 21, 2020, 7:06:39 PM</td> */}
                <td>UPDATED DATE</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.updatedat)}
                </td>
                {/* <td>Jun 5, 2022, 10:46:08 PM</td> */}
              </tr>
              <tr>
                <td>{Constants.UPDATED_BY}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.updatedby)}
                </td>
                {/* <td>techExcelSync</td> */}
                <td>{Constants.Source}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.source)}
                </td>
                {/* <td>-</td> */}
              </tr>
              <tr>
                <td>{Constants.NRI}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.nri)}
                </td>
                {/* <td>No</td> */}
                <td>{Constants.KRA_AGENT}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails.others.kraagent)}
                </td>
                {/* <td>-</td> */}
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* <!-- KYC tabs end--> */}
    </>
  );
}
